module.exports = __webpack_public_path__ + "img/dateSingedEle.2451fb66.svg";